import { defineStore } from 'pinia';
import adminServices from '@/services/adminServices';
import { UseStoreUser } from '@/store/userStore';
import type { LienResponse, CreateLienDTO } from '@/types/api';

export const UseStoreAdmin = defineStore('admin', {
  state: () => ({
    adminLinks: [] as LienResponse[],
  }),
  actions: {
    fetchLinkAdmin(): LienResponse[] {
      return this.adminLinks;
    },
    async loadAdminLinks() {
      const userStore = UseStoreUser();
      await userStore.fetchUserLinks();
      await adminServices.loadAdminLinks(
        links => {
          this.adminLinks = links;
        },
        () => {
          console.error('Failed to fetch Admin links');
        }
      );
    },

    async createAdminLink(linkData: CreateLienDTO & { file?: File }) {
      await adminServices.createLinkByAdmin(
        linkData,
        () => {
          this.loadAdminLinks();
          console.log('Admin link created');
        },
        () => {
          console.error('Failed to create admin link');
        }
      );
    },

    async updateLinkByAdmin(linkData: {
      id: string;
      name?: string;
      url?: string;
      file?: File;
    }) {
      await adminServices.updateLinkByAdmin(
        linkData.id,
        linkData,
        () => {
          this.loadAdminLinks();
          console.log('Link Updated');
        },
        () => {
          console.error('Failed to Update link');
        }
      );
    },

    async deleteAdminLink(linkId: string) {
      await adminServices.deleteLinkByAdmin(
        linkId,
        () => {
          this.loadAdminLinks();
          console.log('Admin link deleted');
        },
        () => {
          console.error('Failed to delete admin link');
        }
      );
    },
  },
});
